//
// Copyright (c) 2011-2020 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';

export const getUserTimeZone = createSelector(
  (state: ICuralateStore) => state.session.timeZone,
  (timeZone) => timeZone.id,
);
